import { zCreateAgentInput } from '@/general/src/agent/utils/createAgent/input.js'
import { z } from 'zod'

export const zCreateAgentsBatchForAdminEndpointInputAgentInput = zCreateAgentInput.pick({
  name: true,
  email: true,
  phone: true,
})
export type CreateAgentsBatchForAdminEndpointInputAgentInput = z.input<
  typeof zCreateAgentsBatchForAdminEndpointInputAgentInput
>

export const zCreateAgentsBatchForAdminEndpointInput = zCreateAgentInput
  .omit({
    email: true,
    phone: true,
    name: true,
  })
  .extend({
    agentsInputs: z.array(zCreateAgentsBatchForAdminEndpointInputAgentInput),
  })
